const icon = require('vue-svgicon');
icon.register({
    'play-round': {
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        data: `<path pid="0" d="M16 0C7.178 0 0 7.178 0 16s7.178 16 16 16 16-7.178 16-16S24.822 0 16 0zm0 31.376C7.521 31.376.624 24.478.624 16S7.522.624 16 .624C24.479.624 31.376 7.522 31.376 16S24.478 31.376 16 31.376z"/><path pid="1" d="M11.513 24.525l11.618-8.276-11.618-8.276z"/>`,
    },
});
